import { render, staticRenderFns } from "./references.vue?vue&type=template&id=148f5324&"
import script from "./references.vue?vue&type=script&lang=js&"
export * from "./references.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports